import React, { useState } from "react";
import { LuMic, LuSquare } from "react-icons/lu";
import { cn, Spinner } from "../../components/ui";
import { useApi } from "../../hooks/useApi";
import { t } from "../../i18n";
import { chatService } from "../../services/chat";
import { useAudioRecorder } from "./useAudioRecorder";

interface DictationButtonProps {
  /** Nome do campo no aria-label ("Ditar nome do paciente"). */
  field: string;
  onText: (text: string) => void;
}

// Microfone dentro do campo: toca para ditar, toca de novo para transcrever.
export const DictationButton: React.FC<DictationButtonProps> = ({ field, onText }) => {
  const recorder = useAudioRecorder("audio");
  const { request, apiFetchForm } = useApi<{ text?: string }>();
  const [sending, setSending] = useState(false);

  const toggle = async () => {
    if (!recorder.recording) return recorder.start();
    const audio = await recorder.stop();
    if (!audio) return;
    setSending(true);
    const res = await request(() => chatService.transcribe(apiFetchForm, audio));
    setSending(false);
    if (res?.text) onText(res.text);
  };

  return (
    <button
      type="button"
      onClick={toggle}
      disabled={sending}
      aria-label={recorder.recording ? t("newOrder.stopDictation") : t("newOrder.dictate", { field })}
      className={cn(
        "absolute right-0 top-0 grid h-11 w-11 place-items-center rounded-full transition-colors focus-visible:outline-none focus-visible:shadow-focus",
        recorder.recording ? "animate-pulse bg-danger text-white" : "text-primary hover:bg-primary-soft"
      )}
    >
      {sending ? <Spinner size={18} /> : recorder.recording ? <LuSquare size={18} aria-hidden /> : <LuMic size={20} aria-hidden />}
    </button>
  );
};
